Em.Handlebars.helper 'numeral', (number, format) ->
  numeral(number).format(format)